export const tabHeader2 = [
  { key: "1", label: "МНН" },
  { key: "2", label: "Кількість розподілена МЗУ" },
  { key: "3", label: "100% Потреба" },
  { key: "4", label: "100% потреба профінансовано" },
  { key: "5", label: "Залишки" },
  { key: "6", label: "Серії/Каталожні номери" },
  { key: "7", label: "Форма випуску" },
  { key: "8", label: "Одиниця виміру" },
  { key: "9", label: "Кратність" },
  { key: "10", label: "Розподілити" },
  { key: "11", label: "База отримувач" },
];

export const subTabHeader2 = [
  { key: "1", label: "МНН ID" },
  { key: "2", label: "МНН" },
  { key: "3", label: "Торгова назва" },
  { key: "4", label: "Дозування" },
  { key: "5", label: "Одиниця випуску" },
  { key: "6", label: "Одиниця виміру" },
  { key: "7", label: "Кратність" },
  { key: "8", label: "100% потреба" },
  { key: "9", label: "100% потреба профінансовано" },
  { key: "10", label: "Серія/Каталожний номер" },
  { key: "11", label: "Залишки" },
  { key: "12", label: "Розподілена кількість" },
];

export const attachmentsTabHeader2 = [
  { key: "1", label: "Тип" },
  { key: "2", label: "Файл" },
  { key: "3", label: "Номер" },
  { key: "4", label: "Дата" },
  { key: "5", label: "Завантаження здійснив" },
  { key: "6", label: "" },
];
